import React from "react";
import "./ProjectQuote.css";
import siteImg from "../../Assets/building.png"; // replace with your image
import { useNavigate } from "react-router-dom";

export default function ProjectQuote() {
    const navigate = useNavigate();
  return (
    <section className="dd-project-section">

      {/* TOP BAR */}
      <div className="dd-project-top">

        <h2>Get a Quote For Your Project</h2>

        <button className="dd-project-quote-btn" onClick={() => navigate("/#contact")}>
          FREE QUOTE
        </button>

      </div>

      {/* MAIN CONTENT */}
      <div className="dd-project-container">

        {/* LEFT IMAGE */}
        <div className="dd-project-image">
          <img src={siteImg} alt="construction" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="dd-project-content">

          <h3>No Project Too Big Or Too Small</h3>

          <div className="dd-project-line"></div>

          <div className="dd-project-text">

            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Sapien, dignissim tristique tellus sed faucibus nullam.
              Tincidunt mauris ut quam sed mauris proin feugiat.
            </p>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Sapien, dignissim tristique tellus sed faucibus nullam.
            </p>

          </div>

          <div className="dd-project-text">

            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Sapien, dignissim tristique tellus sed faucibus nullam.
              Tincidunt mauris ut quam sed mauris proin feugiat.
            </p>

            <button className="dd-project-learn-btn">
              LEARN MORE
            </button>

          </div>

        </div>

      </div>

      {/* STATS SECTION */}
      <div className="dd-project-stats">

        <div className="dd-stat-box dd-stat-green">
          <h4>15+</h4>
          <p>YEARS ESTABLISHED</p>
        </div>

        <div className="dd-stat-box dd-stat-dark">
          <h4>120+</h4>
          <p>COMPLETED PROJECTS</p>
        </div>

      </div>

    </section>
  );
}